<template>
    <div class="dashboard-window" v-if="data">
        <div class="dashboard-window-header">
            <div class="window-header__title">
                Топ клиентов
            </div>
        </div>
        <div class="dashboard-window-body">
            <div class="table">
                <div class="table-body">
                    <table>
                        <thead>
                            <tr>
                                <th>Сотрудник</th>
                                <th>Кол-во заказов</th>
                                <th>Выручка</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="row in data.slice(0, 5)" :key="row.id">
                                <td>
                                    {{ row.name }}
                                </td>
                                <td>
                                    {{ row.orders }}
                                </td>
                                <td>
                                    {{ formatNumber(row.revenue) }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { formatNumber } from '@/utils/numberFormat'

export default {
    data() {
        return {
            testData: [
                {
                    id: 0,
                    name: 'Набиулина Дмитриевна Анастасия',
                    date: new Date(),
                    points: 900
                },
                {
                    id: 1,
                    name: 'Иванов Иванович Константин',
                    date: new Date(),
                    points: 1200
                },
                {
                    id: 2,
                    name: 'Набиулина Дмитриевна Анастасия',
                    date: new Date(),
                    points: 1500
                },
                {
                    id: 3,
                    name: 'Иванов Иванович Константин',
                    date: new Date(),
                    points: 700
                },
            ]
        }
    },

    props: {
        data: {
            type: Object,
            default: null
        }
    },

    methods: {
        formatNumber
    }
}
</script>
<style scoped lang="scss">
.dashboard-window {
    padding: 0 20px 20px 20px;
    display: flex;
    flex-direction: column;
    font-family: 'SFProDisplay', sans-serif;
    height: 100%;
    background: var(--color-white);
    border-radius: 16px;
    border: 1px solid #F5F5F5;
    overflow: hidden;
    
    &-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 16px;
        font-weight: 700;
        height: 64px;
    }

    &-body {
        & .table {
            border: none;
            border-radius: none;
            &-body table {
                min-width: 100%;
                @media only screen and  (max-width: 425px) {
                    min-width: 550px;
                }
            }
            & thead tr th {
                font-size: 12px;
                color: #969696;
                font-weight: 600;
                text-align: start;
                height: 40px;
                border-right: none;
                background: var(--color-white);
            }
            & tbody {
                & tr td {
                    font-weight: 500;
                    height: 40px;
                    text-align: start;
                    background: var(--color-white);
                }
            }
        }
    }
}
</style>